import React from "react";
import { MARQUEE } from "../data/site";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <div className="overflow-hidden border-y border-zinc-200 bg-mist py-6" data-testid="marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((t, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-display text-2xl font-medium tracking-tight text-ink md:text-3xl">
            {t}
            <span className="inline-block h-2 w-2 rotate-45 bg-teal" />
          </span>
        ))}
      </div>
    </div>
  );
};
